<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_CARD_GROUP_CLASS = `${PREFIX_CLASS}card-group`

export default {
  name: 'TCardGroup',
  props: {},
  computed: {
    classes() {
      return [PREFIX_CARD_GROUP_CLASS]
    }
  }
}
</script>



// WEBPACK FOOTER //
// card-group.vue?3de21ef2